import { TeamMembershipSync } from '@/components/utils/team-membership-sync';
import { isUserQueryBlockedRoute } from '@/hooks/query/useQueryUser';
import { useRouter } from 'next/router';

/**
 * Mounts {@link TeamMembershipSync} only on routes where user/team queries are allowed.
 * Haiku pre-auth launch routes have no authenticated user yet.
 *
 * OpenFeature context sync is mounted separately and is not gated here.
 */
export function SafeTeamMembershipSync() {
  const { pathname } = useRouter();
  if (isUserQueryBlockedRoute(pathname)) return null;
  return <TeamMembershipSync />;
}
